import AbsencesService from "services/AbsensesService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getAbsences = createAsyncThunk(
    "absences/getAll",
    async ({ type, page = 1 }, { rejectWithValue }) => {
        try {
            const response = await AbsencesService.getAbsences({ type, page });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

export const getAbsenceById = createAsyncThunk(
    "absences/getAbsenceById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await AbsencesService.getAbsenceById(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

export const createAbsence = createAsyncThunk(
    "absences/createAbsence",
    async (data, { rejectWithValue }) => {
        try {
            const response = await AbsencesService.createAbsence(data);
            return response.data.absenceManagement;
        } catch (error) {
            return rejectWithValue(
                error.response.data.error || "Internal server error"
            );
        }
    }
);

export const updateAbsenceById = createAsyncThunk(
    "absences/updateAbsenceById",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await AbsencesService.updateAbsence(id, data);
            return response.data?.absenceManagement;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Internal server error"
            );
        }
    }
);

export const deleteAbsenceById = createAsyncThunk(
    "absences/deleteAbsenceById",
    async (id, { rejectWithValue }) => {
        try {
            await AbsencesService.deleteAbsenceById(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

const initialState = {
    absences: [],
    absence: null,
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
};

const absencesSlice = createSlice({
    name: "absences",
    initialState,
    reducers: {
        setAbsences: (state, { payload }) => {
            state.absences = payload;
        },
        setAbsence: (state, { payload }) => {
            state.absence = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },
    extraReducers: {
        [getAbsences.pending]: (state) => {
            state.loading = true;
        },
        [getAbsences.fulfilled]: (state, { payload }) => {
            state.absences = payload.data;
            state.totalPages = payload.pages;
            state.currentPage = payload.page;
            state.loading = false;
        },
        [getAbsences.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [getAbsenceById.pending]: (state) => {
            state.loading = true;
        },
        [getAbsenceById.fulfilled]: (state, { payload }) => {
            state.absence = payload;
            state.loading = false;
        },
        [getAbsenceById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [createAbsence.pending]: (state, { payload }) => {
            state.loading = true;
        },
        [createAbsence.fulfilled]: (state, { payload }) => {
            state.absences.push(payload);
            state.loading = false;
        },
        [createAbsence.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [updateAbsenceById.pending]: (state) => {
            state.loading = true;
        },
        [updateAbsenceById.fulfilled]: (state, { payload }) => {
            state.absences = state.absences.map((absence) =>
                absence._id === payload._id ? payload : absence
            );
            state.loading = false;
        },
        [updateAbsenceById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [deleteAbsenceById.pending]: (state) => {
            state.loading = true;
        },
        [deleteAbsenceById.fulfilled]: (state, { payload }) => {
            state.absences = state.absences.filter(
                (absence) => absence._id !== payload
            );
            state.loading = false;
        },
        [deleteAbsenceById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
    },
});

export const { setAbsences, setAbsence, setLoading, setError } =
    absencesSlice.actions;

export default absencesSlice.reducer;
